import request from '../index';

// 任务分配规则API
export const taskAllocationApi = {
  // 获取分配规则列表
  getRules: () => request.get('/task-allocation/rules'),
  
  // 计算分配预览
  calculate: (data) => request.post('/task-allocation/calculate', data),
  
  // 执行分配
  execute: (taskId) => request.post('/task-allocation/execute', { taskId }),
};

// 消费返佣API
export const consumptionRebateApi = {
  // 计算返佣
  calculate: (data) => request.post('/consumption/calculate-rebate', data),
  
  // 提交消费记录
  submit: (data) => request.post('/consumption/submit', data),
};

// 现金分卡API
export const cashCardApi = {
  // 生成购买码
  generateCode: (data) => request.post('/cash-card/generate-code', data),
  
  // 兑换
  redeem: (data) => request.post('/cash-card/redeem', data),
  
  // 获取列表
  getList: (params) => request.get('/cash-card/list', { params }),
};

// 积分市场API
export const creditMarketApi = {
  // 获取积分列表
  getListings: (params) => request.get('/credit-market/listings', { params }),
  
  // 发布出售
  sell: (data) => request.post('/credit-market/sell', data),
  
  // 购买
  buy: (data) => request.post('/credit-market/buy', data),
  
  // 取消订单
  cancel: (data) => request.post('/credit-market/cancel', data),
};
